/**
 * Mock comment/question data for testing and development
 * Follows the API response structure from /v1/comment/list/comments
 */

export const MOCK_COMMENTS_API_RESPONSE = {
  response: [
    // User 1: Jarwin Marinas (Current logged-in user) - 3 questions
    {
      uuid: 'eab2fceb-1b64-43ba-8502-988902f49dd7',
      firstName: 'Jarwin',
      lastName: 'Marinas',
      linkedinProfile: 'https://linkedin.com/in/jarwin-marinas',
      personalWebsite: null,
      profileImageUrl: 'https://i.pravatar.cc/150?img=12',
      email: 'jmarinas@trustbridgeglobal.com',
      userQuestions: [
        // Question with answer
        {
          uuid: '15242db5-5b98-4f46-98ae-71ebeaabf702',
          content: 'What is the expected timeline for completing this project? Are there any major milestones we should be aware of?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: 'answer-001',
          updateTime: '2025-12-16T08:18:33.404723',
          anonymous: false,
          userInfo: {
            userUuid: 'eab2fceb-1b64-43ba-8502-988902f49dd7',
            firstName: 'Jarwin',
            lastName: 'Marinas',
            linkedinProfile: 'https://linkedin.com/in/jarwin-marinas',
            personalWebsite: null,
            profileImageUrl: 'https://i.pravatar.cc/150?img=12',
            email: 'jmarinas@trustbridgeglobal.com'
          },
          answer: {
            uuid: 'answer-001',
            content: 'Great question! The project timeline is 18 months with three major milestones: Phase 1 (Months 1-6) focuses on infrastructure setup, Phase 2 (Months 7-12) on program implementation, and Phase 3 (Months 13-18) on evaluation and scaling. We will provide quarterly progress reports to all donors.',
            commentType: 'COMMENT',
            entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
            updateTime: '2025-12-16T09:30:15.123456',
            userInfo: {
              userUuid: 'pm-uuid-001',
              firstName: 'Sarah',
              lastName: 'Johnson',
              linkedinProfile: null,
              personalWebsite: null,
              profileImageUrl: 'https://i.pravatar.cc/150?img=45',
              email: 'sjohnson@globaleducation.org'
            }
          }
        },
        // Question without answer (pending)
        {
          uuid: 'e825c7c6-552d-4089-8f06-caf6f3e007d9',
          content: 'How do you measure the success of your educational programs? What metrics do you track?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: null,
          updateTime: '2025-12-15T14:20:45.123409',
          anonymous: false,
          userInfo: {
            userUuid: 'eab2fceb-1b64-43ba-8502-988902f49dd7',
            firstName: 'Jarwin',
            lastName: 'Marinas',
            linkedinProfile: 'https://linkedin.com/in/jarwin-marinas',
            personalWebsite: null,
            profileImageUrl: 'https://i.pravatar.cc/150?img=12',
            email: 'jmarinas@trustbridgeglobal.com'
          },
          answer: null
        },
        // Another question with answer
        {
          uuid: 'q-jarwin-003',
          content: 'Can you provide more details about how local communities are involved in the project planning and execution?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: 'answer-003',
          updateTime: '2025-12-14T10:15:30.789012',
          anonymous: false,
          userInfo: {
            userUuid: 'eab2fceb-1b64-43ba-8502-988902f49dd7',
            firstName: 'Jarwin',
            lastName: 'Marinas',
            linkedinProfile: 'https://linkedin.com/in/jarwin-marinas',
            personalWebsite: null,
            profileImageUrl: 'https://i.pravatar.cc/150?img=12',
            email: 'jmarinas@trustbridgeglobal.com'
          },
          answer: {
            uuid: 'answer-003',
            content: 'Community involvement is at the heart of our approach. We conduct extensive consultations with local leaders, teachers, and parents before starting any program. Each community forms a Project Advisory Committee that meets monthly to guide implementation decisions. Additionally, we hire local staff and teachers, ensuring the community has ownership of the project.',
            commentType: 'COMMENT',
            entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
            updateTime: '2025-12-14T16:45:20.345678',
            userInfo: {
              userUuid: 'pm-uuid-001',
              firstName: 'Sarah',
              lastName: 'Johnson',
              linkedinProfile: null,
              personalWebsite: null,
              profileImageUrl: 'https://i.pravatar.cc/150?img=45',
              email: 'sjohnson@globaleducation.org'
            }
          }
        }
      ]
    },
    // User 2: Maria Garcia - 2 questions
    {
      uuid: 'user-uuid-002',
      firstName: 'Maria',
      lastName: 'Garcia',
      linkedinProfile: 'https://linkedin.com/in/maria-garcia',
      personalWebsite: 'https://mariagarcia.com',
      profileImageUrl: 'https://i.pravatar.cc/150?img=32',
      email: 'maria.garcia@email.com',
      userQuestions: [
        {
          uuid: 'q-maria-001',
          content: 'What percentage of donations goes directly to program costs versus administrative overhead?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: 'answer-004',
          updateTime: '2025-12-13T09:30:12.456789',
          anonymous: false,
          userInfo: {
            userUuid: 'user-uuid-002',
            firstName: 'Maria',
            lastName: 'Garcia',
            linkedinProfile: 'https://linkedin.com/in/maria-garcia',
            personalWebsite: 'https://mariagarcia.com',
            profileImageUrl: 'https://i.pravatar.cc/150?img=32',
            email: 'maria.garcia@email.com'
          },
          answer: {
            uuid: 'answer-004',
            content: 'Excellent question! We maintain a 85/15 ratio - 85% of all donations go directly to program implementation, while 15% covers administrative costs and fundraising. This is well above industry standards. We publish detailed financial reports quarterly, and our books are audited annually by an independent firm. You can view our latest financial report in the Documents tab.',
            commentType: 'COMMENT',
            entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
            updateTime: '2025-12-13T11:15:45.234567',
            userInfo: {
              userUuid: 'pm-uuid-002',
              firstName: 'Michael',
              lastName: 'Chen',
              linkedinProfile: null,
              personalWebsite: null,
              profileImageUrl: 'https://i.pravatar.cc/150?img=51',
              email: 'mchen@globaleducation.org'
            }
          }
        },
        {
          uuid: 'q-maria-002',
          content: 'Are there opportunities for donors to visit the project sites and see the impact firsthand?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: null,
          updateTime: '2025-12-12T15:45:30.987654',
          anonymous: false,
          userInfo: {
            userUuid: 'user-uuid-002',
            firstName: 'Maria',
            lastName: 'Garcia',
            linkedinProfile: 'https://linkedin.com/in/maria-garcia',
            personalWebsite: 'https://mariagarcia.com',
            profileImageUrl: 'https://i.pravatar.cc/150?img=32',
            email: 'maria.garcia@email.com'
          },
          answer: null
        }
      ]
    },
    // User 3: David Thompson - 1 question with answer
    {
      uuid: 'user-uuid-003',
      firstName: 'David',
      lastName: 'Thompson',
      linkedinProfile: null,
      personalWebsite: null,
      profileImageUrl: 'https://i.pravatar.cc/150?img=18',
      email: 'david.thompson@email.com',
      userQuestions: [
        {
          uuid: 'q-david-001',
          content: 'What kind of teacher training programs are included in this project? Will teachers receive ongoing support?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: 'answer-005',
          updateTime: '2025-12-11T13:20:15.123456',
          anonymous: false,
          userInfo: {
            userUuid: 'user-uuid-003',
            firstName: 'David',
            lastName: 'Thompson',
            linkedinProfile: null,
            personalWebsite: null,
            profileImageUrl: 'https://i.pravatar.cc/150?img=18',
            email: 'david.thompson@email.com'
          },
          answer: {
            uuid: 'answer-005',
            content: 'Teacher training is a cornerstone of our approach! All teachers participate in a 6-week intensive training program covering modern teaching methodologies, classroom management, and subject-specific content. After the initial training, teachers receive monthly mentoring sessions from experienced educators, attend quarterly workshops, and have access to our online resource library. We also create peer learning groups where teachers support each other.',
            commentType: 'COMMENT',
            entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
            updateTime: '2025-12-11T16:30:45.654321',
            userInfo: {
              userUuid: 'pm-uuid-001',
              firstName: 'Sarah',
              lastName: 'Johnson',
              linkedinProfile: null,
              personalWebsite: null,
              profileImageUrl: 'https://i.pravatar.cc/150?img=45',
              email: 'sjohnson@globaleducation.org'
            }
          }
        }
      ]
    },
    // Anonymous user - 2 questions
    {
      uuid: null,
      firstName: 'ANONYMOUS',
      lastName: 'ANONYMOUS',
      linkedinProfile: null,
      personalWebsite: null,
      profileImageUrl: null,
      email: null,
      userQuestions: [
        {
          uuid: '7c76c564-5815-4623-b412-1102fbc927ab',
          content: 'How do you ensure the sustainability of the programs after the project funding ends?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: 'answer-006',
          updateTime: '2025-12-10T08:05:23.873631',
          anonymous: true,
          userInfo: null,
          answer: {
            uuid: 'answer-006',
            content: 'Sustainability is built into our project design from day one. We work with government education departments to integrate our programs into their systems, train local staff who will continue the work, and establish community fundraising mechanisms. By project end, the local community and government partners are fully equipped to continue and expand the programs independently.',
            commentType: 'COMMENT',
            entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
            updateTime: '2025-12-10T10:20:00.111222',
            userInfo: {
              userUuid: 'pm-uuid-001',
              firstName: 'Sarah',
              lastName: 'Johnson',
              linkedinProfile: null,
              personalWebsite: null,
              profileImageUrl: 'https://i.pravatar.cc/150?img=45',
              email: 'sjohnson@globaleducation.org'
            }
          }
        },
        {
          uuid: 'q-anon-002',
          content: 'What is your policy on safeguarding children involved in the program?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: null,
          updateTime: '2025-12-09T14:30:50.246813',
          anonymous: true,
          userInfo: null,
          answer: null
        }
      ]
    },
    // User 4: Emily Wang - 1 pending question
    {
      uuid: 'user-uuid-004',
      firstName: 'Emily',
      lastName: 'Wang',
      linkedinProfile: 'https://linkedin.com/in/emily-wang',
      personalWebsite: null,
      profileImageUrl: 'https://i.pravatar.cc/150?img=28',
      email: 'emily.wang@email.com',
      userQuestions: [
        {
          uuid: 'q-emily-001',
          content: 'Do you have any data on student performance improvements from previous similar projects?',
          commentType: 'QUESTION',
          entityUuid: '923fcd98-60fd-4bd1-9e2b-cf742308e5f2',
          questionUuid: null,
          answerUuid: null,
          updateTime: '2025-12-08T11:15:20.567890',
          anonymous: false,
          userInfo: {
            userUuid: 'user-uuid-004',
            firstName: 'Emily',
            lastName: 'Wang',
            linkedinProfile: 'https://linkedin.com/in/emily-wang',
            personalWebsite: null,
            profileImageUrl: 'https://i.pravatar.cc/150?img=28',
            email: 'emily.wang@email.com'
          },
          answer: null
        }
      ]
    }
  ]
};
